import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "navigation-guide" }
const _hoisted_2 = { class: "yycj" }
const _hoisted_3 = { class: "yycj-content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "content-title" }
const _hoisted_7 = { class: "wmdys" }
const _hoisted_8 = { class: "wmdys-content" }
const _hoisted_9 = { class: "wmdys-content-list" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "list-box" }

import SubTitle from '@/components/SubTitle.vue';
import { modelTypes } from '@/config';
import ExampleIntroduction from '@/components/common/ExampleIntroduction.vue';
import StepProcess from '@/components/common/StepProcess.vue';
import { exampleDatas } from '@/config/index'
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationGuide',
  setup(__props) {

const wmdysDataList = [
  {
    title: '沉浸式体验',
    content: 'AR导航导览通过创建虚拟场景和互动元素，极大地提升了游览的乐趣和参与度。',
    url: require('@/assets/images/ar-images/icon/cjs-icon.png')
  },
  {
    title: '精准导航',
    content: 'AR导航导览能够为用户提供厘米级的定位精度，确保用户不会迷路或错过重要景点。',
    url: require('@/assets/images/ar-images/icon/jzdh-icon.png')
  },
  {
    title: '个性化服务',
    content: 'AR导航导览支持定制化开发，如选择游览路线、景点介绍和互动体验等，使旅游过程更加灵活多样。',
    url: require('@/assets/images/ar-images/icon/gxhfw-icon.png')
  },
  {
    title: '丰富的互动元素',
    content: 'AR导航导览中融入如寻宝、解谜等趣味游戏，及AR弹幕等社交互动功能，增加游览的趣味性和挑战性。',
    url: require('@/assets/images/ar-images/icon/hdys-icon.png')
  },
  {
    title: '跨平台支持',
    content: 'AR导航导览系统支持多种设备平台，如iOS、Android等，确保用户在不同设备上都能获得一致的使用体验。',
    url: require('@/assets/images/ar-images/icon/kpt-icon.png')
  }
]

const handleEvent = () => {
  let contactUsTop: any = store.state.contactUsTop;
  contactUsTop = {
    bottom: 457 + 'rem'
  }
  store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubTitle, { "title-text": "应用场景" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("main", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modelTypes)['navigation-guide'], (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item.header
            }, [
              _createElementVNode("img", {
                src: item.image,
                alt: ""
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.remarkList[0]), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.header), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(SubTitle, {
        "mode-class": "black-style",
        "title-text": "我们的优势"
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(wmdysDataList, (item, index) => {
            return _createElementVNode("div", { key: index }, [
              _createElementVNode("img", {
                src: item.url
              }, null, 8, _hoisted_10),
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, _toDisplayString(item.content), 1)
              ])
            ])
          }), 64))
        ])
      ])
    ]),
    _createVNode(ExampleIntroduction, {
      exampleData: _unref(exampleDatas).ardh
    }, null, 8, ["exampleData"]),
    _createVNode(StepProcess, {
      "step-title": ['沉浸式体验', '一站式部署流程'],
      "step-type": "step1"
    }),
    _createElementVNode("div", { class: "counselling-btn" }, [
      _createElementVNode("div", {
        class: "btn",
        onClick: handleEvent
      }, "合作咨询")
    ])
  ]))
}
}

})